/**
 * The meta game's refusal codes (@highmarch/domain meta/*, @highmarch/app economy, forge, market, orders, modes) as the Commander
 * reads them (M39 copy pass): what is missing and, where there is one, the way out. Every surface that toasts a code
 * outside a battle ends here, so no raw code ("no such item") ever reaches the screen.
 */
const WORDS: Readonly<Record<string, string>> = {
  "not enough gold": "Not enough gold: win a battle or collect Tribute",
  "not enough gems": "Not enough gems: stars, bosses and Orders pay them",
  "not enough Marks": "Not enough Marks: sell spare gear at the Market",
  "not enough marks": "Not enough Marks: sell spare gear at the Market",
  "not enough essence": "Not enough Forge Essence: salvage spares or win battles",
  "not enough sigils": "Not enough sigils for that",
  "not here": "Head back to the hub for that",
  "you hold all you can carry": "Your wagons are full: use some supplies first",
  "not saving here": "The game is open in another tab. Carry on there",
  "offer changed": "That offer just changed: take another look",
  "inventory changed": "Your stash just changed: take another look",
  "already bought today": "Bought already today. Back tomorrow",
  "daily limit reached": "That's today's limit. Back tomorrow",
  "sold out": "Sold out. Back at the next restock",
  "no offer today": "Nothing on offer today",
  "all builders owned": "Every builder is hired",
  "no free builder": "Every builder is busy",
  "a builder is free": "A builder is free: start it now",
  "queue full": "Every queue slot is taken",
  "already queued": "Already in the queue",
  "already upgrading": "Already being upgraded",
  "too much time left": "Too long left for a free finish",
  "no such job": "That upgrade is already done",
  "max level": "Already at its top level",
  "at its cap": "Already at its tower's level: raise the tower first",
  "level too low": "That tower's level is too low for it",
  "already researched": "Already researched",
  "vip level too low": "Your VIP level is too low for this one",
  "no reroll left today": "No swaps left today",
  "no changes left today": "No changes left today",
  "no refresh left today": "No refreshes left today. New stock tomorrow",
  "nothing else to offer": "No other order to swap in right now",
  "already claimed": "Already claimed",
  "already complete": "Already done",
  "not reached": "Not reached yet",
  "locked": "It's locked: unlock it first",
  "bound": "Bound gear can't be traded",
  "equipped": "It's worn: take it off first",
  "already equipped": "Already worn",
  "not equipped": "It isn't worn",
  "slot occupied": "That socket is taken",
  "slot does not fit this target": "It doesn't fit that socket",
  "tower and fortress gear do not mix": "Tower gear and fortress gear don't mix",
  "rarities differ": "All three must share a rarity",
  "needs three of a rarity": "Fusion takes three of a rarity",
  "too many sigils": "Too many sigils for this fusion",
  "fodder is worn": "A spare is still worn: take it off first",
  "fodder is locked": "A spare is locked: unlock it first",
  "mythic needs confirmation": "Confirm the Mythic first",
  "gold already spent": "That gold is already spent",
  "essence already spent": "That essence is already spent",
};

/** The words for `code`; an unknown code reads as a plain "not now" rather than leaking the code. */
export function refusalWords(code: string): string {
  return WORDS[code] ?? (code.startsWith("not enough") ? "Not enough to pay for that" : "Can't do that right now");
}
